import { type Framework } from '@toeverything/infra';

import { DocsService } from '../doc';
import { JournalService } from '../journal';
import { WorkspaceScope } from '../workspace';
import { JournalRepeatService } from './services/journal-repeat';

export {
  type JournalDocRef,
  JournalRepeatService,
  type RepeatSeriesSummary,
  today,
} from './services/journal-repeat';
export {
  describeRepeatRule,
  expandRepeatRule,
  formatRepeatRule,
  JOURNAL_DATE_FORMAT,
  MAX_REPEAT_OCCURRENCES,
  parseRepeatRule,
  REPEAT_CONFIRM_THRESHOLD,
  type RepeatBound,
  type RepeatInterval,
  type RepeatRule,
} from './repeat-rule';

export function configureJournalRepeatModule(framework: Framework) {
  framework
    .scope(WorkspaceScope)
    .service(JournalRepeatService, [DocsService, JournalService]);
}
